import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-current_step",
  "use": "icon-current_step-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-current_step\">\r\n<rect width=\"20\" height=\"20\" rx=\"10\" fill=\"#4382E3\" />\r\n<path d=\"M8.91211 14L8.08761 13.1755L11.2631 10L8.08761 6.8245L8.91211 6L12.9121 10L8.91211 14Z\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol